import * as React from 'react';
import { Box, Typography } from '@mui/material';
// import { Link } from 'react-router-dom';

// import Breadcrumb from 'components/breadcrumbs';
import WorkflowExecutionFilters from './filters';
import WorkflowExecutionSummary from './executionSummary';
import WorkflowExecutionTable from './table';
import { useAppDispatch } from 'hooks/useRedux';
import {
  getWorkflowExecutionStats,
  getWorkflowExecutionSummary,
} from 'store/reducer/workflowReducer/action';
import Loader from 'components/loader';
// import { kollectAITheme } from 'config/theme';

const WorkflowExecutionDetails = () => {
  const dispatch = useAppDispatch();

  const [loading, setLoading] = React.useState(false);

  const getExecutionSummary = React.useCallback(async () => {
    try {
      setLoading(true);
      await dispatch(getWorkflowExecutionSummary());
      await dispatch(getWorkflowExecutionStats({ days: 7 }));
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  React.useEffect(() => {
    getExecutionSummary();
  }, [getExecutionSummary]);

  const handlePagination = async (page: number) => {
    try {
      setLoading(true);
      await dispatch(getWorkflowExecutionStats({ days: 7, page }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Loader loading={loading} />
      <Box sx={{ padding: '0 2rem 1rem 3rem' }}>
        {/* <Box sx={{ position: 'relative', marginBottom: '2rem' }}> */}
        <Typography align='center' fontSize='1.5rem' mb='1.5rem'>
          Workflow Execution Details
        </Typography>

        {/* <Box
            sx={{
              position: 'absolute',
              right: 0,
              top: '4px',
              '& a': {
                fontSize: '1.1rem',
                color: kollectAITheme.primaryColor,
                fontWeight: 600,
              },
            }}
          >
            <Link to='/workflow'>Go to create workflow</Link>
          </Box>
        </Box> */}

        <WorkflowExecutionFilters setLoading={setLoading} />

        <WorkflowExecutionSummary />

        <WorkflowExecutionTable
          onPaginationChange={handlePagination}
          setLoading={setLoading}
        />
      </Box>
    </>
  );
};

export default WorkflowExecutionDetails;
